module.exports = __webpack_public_path__ + "static/media/lirian-min.7f708251.png";